import * as React from "react"

const RoundedLink = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" {...props}>
    <path d="M5.33 4.5a3.5 3.5 0 0 0 0 7h.95v1h-.95a4.5 4.5 0 0 1 0-9h.95v1h-.95zm-.94 3h7.22v1H4.4v-1zm5.83-4h-.5v1h.95a3.5 3.5 0 0 1 0 7h-.95v1h.95a4.5 4.5 0 0 0 0-9h-.45z" />
  </svg>
)

export default RoundedLink
